const SUFFIX = '...';

export type CharactersFilter = (input: string, maxChars: number, canBreakOnWord?: boolean) => string;

/**
 * @ngdoc filter
 * @name characters
 * @module portaro.filters
 * @kind function
 *
 * @param {string} input String to trim.
 * @param {number} maxChars Length to trim.
 * @param {boolean=} canBreakOnWord If true, last word can be breaked. Default `false`.
 *
 * @return {string} Trimmed string
 *
 * @description
 * Filter limits maximum length of input. If input is longer than the given threshold, it will be trimmed and on the end will be added `...`.
 * If `maxChars` is not a number, the filter returns untouched input. If `maxChars` <= 0, the filter returns an empty string.
 * The last argument defines if a filter can break a word.
 */
export default function charactersFilter(): CharactersFilter {
    return (input: string, maxChars: number, canBreakOnWord: boolean = false): string => { // "lorem ipsum", 10
        if (isNaN(maxChars)) {
            return input;
        }

        if (maxChars <= 0) {
            return '';
        }

        if (input && input.length > maxChars) {
            input = input.substring(0, maxChars - SUFFIX.length); // "lorem ipsum" -> "lorem i"

            if (canBreakOnWord) {
                // trim
                while (input.charAt(input.length - 1) === ' ') { // "lorem i"
                    input = input.substr(0, input.length - 1);
                }
            } else {
                const lastspace: number = input.lastIndexOf(' ');
                // get last space
                if (lastspace !== -1) {
                    input = input.substr(0, lastspace); // "lorem"
                }
            }
            return input + SUFFIX; // "lorem..." / "lorem i..."
        }
        return input;
    };
}

charactersFilter.filterName = 'characters';